import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid } from "@mui/material";
import frameImg from "../images/frame.svg";
// import risingBottom from "../images/risingBottom.png";
import useStyles from "../css/comparePackageStyle.js";
// import { Button } from "bootstrap";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";


export default function Home() {
    const classes = useStyles;  // Use the styles
    const navigate = useNavigate();

    function createData(
        Features,
        Free,
        Basic,
        Advance
    ) {
        return { Features, Free, Basic, Advance };
    }

    const getIcon = (isActive) => (
        <CheckCircleIcon sx={{ color: isActive ? '#0D8B5A' : 'transparent' }} />
    );

    const rows = [
        createData('Business Details', getIcon(true), getIcon(true), getIcon(true)),
        createData('Contact Details (Address, Phone, Email & Website)', getIcon(true), getIcon(true), getIcon(true)),
        createData('Set Opening Hours', getIcon(true), getIcon(true), getIcon(true)),
        createData('Business Description', getIcon(true), getIcon(true), getIcon(true)),
        createData('Add Logo & Slogan', getIcon(true), getIcon(true), getIcon(true)),
        createData('Add 10 FAQ', getIcon(false), getIcon(true), getIcon(true)),
        createData('Get Reviews & Rating', getIcon(false), getIcon(true), getIcon(true)),
        createData('Add All Social Contacts Include', getIcon(false), getIcon(true), getIcon(true)),
        createData('Add Photo ', getIcon(false), getIcon(true), getIcon(true)),
        createData('Add Discount Vouchers', getIcon(false), getIcon(true), getIcon(true)),
        createData('Set Promotional Ads', getIcon(false), getIcon(false), getIcon(true)),
        createData('Top Priority Listing in Searches', getIcon(false), getIcon(false), getIcon(true)),
        createData('Add 25 FAQ', getIcon(false), getIcon(false), getIcon(true)),
    ];

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={classes.container} // Apply container styles
        >
            <Box sx={{ pt: 1, }}>
                <Box id="Compare_package"
                    sx={{
                        ...classes.headerBox,
                        backgroundImage: `url(${frameImg})`, // Set background image inline
                        mt: 20,
                    }}
                >
                    <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid item lg={8} md={9} sm={10} xs={11}>
                            <Typography variant="h3" sx={classes.headerTextTitle}>
                                For Muslim Business Owners
                            </Typography>
                            <Typography variant="body1" sx={classes.headerText}>
                                To promote your business, join our subscription plans and unlock opportunities for promoting your business. Begin by selecting a package that suits your needs and create your exclusive business profile.
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Grid container sx={classes.gridContainer}>
                <Grid lg={7} md={7} sm={12} xs={12}>
                    <Typography variant="h6" sx={classes.gridTitle}>
                        Compare Packages
                    </Typography>
                    <Typography variant="body1" sx={{ ...classes.gridText, color: 'black' }}>
                        Subscribe our{' '}
                        <span style={{ color: '#0D8B5A', fontWeight: 'bold' }}>Advance Package</span> to avail all features of{' '}
                        <span style={{ color: '#0D8B5A', fontWeight: 'bold' }}>AMBD</span> including{' '}
                        <span style={{ color: '#0D8B5A', fontWeight: 'bold' }}>Promotional Ads</span> shown on top of all Businesses.
                    </Typography>
                    <Box sx={{ pt: 3 }}>
                        <TableContainer
                            component={Paper}
                            sx={{
                                background: 'transparent', // Transparent background
                                boxShadow: 'none',         // Remove shadow
                                border: 'none'             // Remove border
                            }}
                        >
                            <Table
                                sx={{
                                    minWidth: 350,
                                    borderCollapse: 'collapse', // Ensure no cell gaps
                                }}
                                aria-label="simple table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={classes.tableHeading}>Features</TableCell>
                                        <TableCell sx={classes.tableHeading} align="center">Free</TableCell>
                                        <TableCell sx={classes.tableHeading} align="center">Basic</TableCell>
                                        <TableCell sx={{ ...classes.tableHeading, background: '#0D8B5A0A' }} align="center">Advance&nbsp;(g)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>{rows.map((row) => (
                                    
                                        <TableRow
                                            key={row.Features}
                                            sx={{
                                                '&:last-child td, &:last-child th': { borderBottom: 'none' } // Remove border for last row
                                            }}
                                        >
                                            <TableCell component="th" scope="row" sx={classes.tableText}>
                                                {row.Features}
                                            </TableCell>
                                            <TableCell align="center" sx={{ borderBottom: '1px solid #E0E0E0' }}>{row.Free}</TableCell>
                                            <TableCell align="center" sx={{ borderBottom: '1px solid #E0E0E0' }}>{row.Basic}</TableCell>
                                            <TableCell align="center" sx={{ borderBottom: '1px solid #E0E0E0', background: '#0D8B5A0A' }}>{row.Advance}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ mt: 3, pb: 3 }}>
                <Typography variant="body1" sx={{ ...classes.gridFooterText, color: 'black' }}>
                    By completing your purchase, you agree to our{' '}
                    <Box
                        component="span"
                        sx={{ color: '#0D8B5A', fontWeight: 'bold', cursor: 'pointer' }}
                        onClick={() => navigate('/payment-policy')} // Navigate to Payment Policy
                    >
                        Payment Policy,
                    </Box>{' '}
                    which outlines the terms and conditions of payment and refunds.
                </Typography>
            </Box>
        </Container>
    );
}
